//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import Component from '../../../base/Component'
const NjNavItems = Component.extend({
  name: 'NjNavItems',
  props: {
    ariaLabel: {
      type: String,
      default: 'Nav'
    },
    items: {
      type: Array,
      default () {
        return []
      },
      required: true
    },
    classes: {
      type: Object,
      default () {
        return {
          nav: '',
          navItems: '',
          navItem: 'cursor-pointer'
        }
      }
    },
    navType: {
      type: String,
      default: 'single',
      validator: value =>
        ['dropdown', 'single'].includes(value.toLowerCase())

    },
    tag: {
      type: String,
      default: 'nav',
      validator: value =>
        ['nav', 'div'].includes(value.toLowerCase())
    }
  },
  computed: {
    // @TODO: rename to NjNavDropdownItem
    navItemType () {
      return this.navType === 'dropdown' ? 'NjNavDropdownItem' : 'NjNavItem'
    }
  }
})

export default NjNavItems
